




























import VueOptions from '@utils/VueOptions'

settings =
  name: "DropdownFilter"

  vue:
    props: ['label', 'value', 'actions', 'options', 'permit', 'disabled']

    data: ->
      modal:
        show: false

    created: ->
      document.body.addEventListener('click', @hiClickOutside)

    beforeDestroy: ->
      document.body.removeEventListener('click', @hiClickOutside)

    computed:
      hasValue: -> @value.length
      isDisabled: -> @disabled || @requestIsPending
      showActionBar: -> !!!@permit?.hideActionBar
      customWidth: -> @options.width if @options?.width
      align: -> @options?.align || 'left'

      calculatedLabel: ->
        return @label if not @hasValue
        x = @value[0]
        x += " +#{@value.length - 1}" if @value.length > 1
        x

      hasClearAction: -> @actions?.hiClearFilterGroup?
      hasApplyAction: -> @actions?.hiApplyFilters?

    methods:
      hiToggleModal: ->
        @closeSiblingsFilters()
        @modal.show = !@modal.show

      hiCloseModal: ->
        @modal.show = false

      hiClickOutside: (event) ->
        target = event?.target
        isClosest = !!target?.closest('.filter-modal')

        if not isClosest and @modal.show
          event.stopPropagation()
          @hiApplyFilters() 

        @hiCloseModal() if not isClosest

      closeSiblingsFilters: ->
        refs = @$parent.$refs
        Object.keys(refs).forEach((ref) =>
          isDropdownModal = refs[ref]?.modal?.show?
          isSameLabel = refs[ref]?.label is @label
          refs[ref].modal.show = false if isDropdownModal and not isSameLabel
        )

      hiApplyFilters: ->
        @actions?.hiApplyFilters?()
        @hiCloseModal()

      hiClearFilters: ->
        @hiCloseModal()
        @actions?.hiClearFilterGroup?()

export default VueOptions.vue settings
